var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mounting-portal',{attrs:{"mount-to":_vm.mountTo,"append":"","target-slim":"","multiple":""}},[_c('div',{class:_vm.wrapperClass,style:(_vm.style)},[_c('div',_vm._g(_vm._b({ref:"content",class:_vm.contentClass,style:(_vm.contentStyle)},'div',_vm.$attrs,false),_vm.$listeners),[(_vm.show)?[_vm._t("default")]:_vm._e()],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }